import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'
import { EFIconProps } from './IconProps'

export function SearchIcon(iconProps: EFIconProps) {
  const isDark = useAppSelector(isDarkTheme)
  return (
    <svg
      style={{
        height: iconProps.height,
        width: iconProps.width,
        color: 'var(--bs-dark)'
      }}
      width='25'
      height='25'
      viewBox='6 8 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M22.75 24.5234L27 29.5M17.4375 12.5C21.5451 12.5 24.875 15.9722 24.875 19.7439C24.875 23.5156 21.5451 26.5732 17.4375 26.5732C13.3299 26.5732 10 23.5156 10 19.7439C10 15.9722 13.3299 12.5 17.4375 12.5Z'
        stroke={isDark ? 'var(--color-dark-theme)' : 'var(--color-light-theme)'}
        strokeWidth='2'
        strokeLinecap='round'
      />
    </svg>

    // <svg
    // 	style={{
    // 		height: iconProps.height,
    // 		width: iconProps.width,
    // 		color: 'var(--bs-dark)'
    // 	}}
    // 	width='26'
    // 	height='26'
    // 	viewBox={`0 -4 22 26`}
    // 	fill='none'
    // 	xmlns='http://www.w3.org/2000/svg'
    // >
    // 	<path
    // 		d='M0.75 7.5C0.75 11.5041 3.9959 14.75 8 14.75C9.7319 14.75 11.3219 14.1427 12.5688 13.1295L17.4697 18.0303C17.7626 18.3232 18.2374 18.3232 18.5303 18.0303C18.7966 17.7641 18.8208 17.3474 18.6029 17.0538L18.5303 16.9697L13.6295 12.0688C14.6427 10.8219 15.25 9.2319 15.25 7.5C15.25 3.4959 12.0041 0.25 8 0.25C3.9959 0.25 0.75 3.4959 0.75 7.5ZM2.25 7.5C2.25 4.3244 4.8244 1.75 8 1.75C11.1756 1.75 13.75 4.3244 13.75 7.5C13.75 10.6756 11.1756 13.25 8 13.25C4.8244 13.25 2.25 10.6756 2.25 7.5Z'
    // 		fill={isDark ? 'var(--color-dark-theme)' : 'var(--color-light-theme)'}
    // 	/>
    // </svg>
  )
}
